import ErrorPage from '../ErrorPage/ErrorPage';
export const getErrorCode = function(props,code) {
    const hasErrors = props.hasOwnProperty('errors') && props.errors;
    return hasErrors && props.errors.code || code;
};

export const getErrorType = function(code) {
    const map = {
        '403': 'noPurview'
        ,'404': '404'
        ,'500': '500'
    };
    return map[code] || '';
};

export function errorPage(props,code) {
    const errorCode = getErrorCode(props, code);
    if(errorCode) {
        return <ErrorPage errorType={getErrorType(errorCode)}></ErrorPage>;
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/components/util/pageError.js